// extracted by mini-css-extract-plugin
export default {"header":"app_header__muBoD","browse_section":"app_browse_section__6K8Tc","subheader":"app_subheader__CRE1v","subtitle":"app_subtitle__klOCA","curious":"app_curious__ovXb-"};